import React from 'react'
import {Box, Heading} from "grommet";

const FormSection = props => {
    const { heading, children } = props
    
    return (
        <Box
            pad={{'vertical': '15px'}}
            border={{
                "color": "border",
                "size": "xsmall",
                "style": "solid",
                "side": "top"
            }}
        >
            <Box>
                {heading
                    ? <Heading margin='none' level='4'>{heading}</Heading>
                    : null}
                {children}
            </Box>
        </Box> 
    )
}

export default FormSection